import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import MUIDataTable from 'mui-datatables';
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import Checkbox from '@mui/material/Checkbox'
import Selectsearch from "react-select";
import {
    FormGroup,
    Label,
    Input, 
} from 'reactstrap';

import { 
    getMonthContractInstallment,
    updateInstallmentStatus,
    emailInstallmentDue,
} from 'Actions';

class ContractsInstallment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewdiv: true,
      months: [],
      finmonth:'',
      viewmonth:false,
      selectedMonth: '',
      selectstatus:0,
      editAgreementModal:false,
      feebreakid:'',
      paymentstatus:'',
      paymentnotes:'',
      payerror:'',
    };
  }

  UNSAFE_componentWillMount() {
    this.props.getMonthContractInstallment('',0);
    this.generateMonthList();
  }

  // generateMonthList() {
  //   const currentDate = new Date();
  //   const months = Array.from({ length: 13 }, (_, index) => {
  //       if(index==0){
  //           const value = ``;
  //           const label = `All`;

  //           return { value, label };
  //       }else{  
  //           const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + index-1, 1);
  //           const month = newDate.toLocaleString('en-US', { month: 'long' });
  //           const year = newDate.getFullYear();
  //           const value = `${newDate.getMonth() + 1}-${year}`;
  //           const label = `${month} ${year}`;

  //           return { value, label };
  //       }
  //   });

  //   this.setState({ months });
  // }

  generateMonthList() {
    const currentDate = new Date();
    const financialYearStartMonth = 3; // Assuming financial year starts from April
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    const startYear = currentMonth >= financialYearStartMonth ? currentYear : currentYear - 1;
  
    const months = [];
    const value = ``;
    const label = `All Month`;
    months.push({ value, label });
    for (let i = financialYearStartMonth; i <= 36; i++) {
      const newDate = new Date(startYear, i, 1);
      const month = newDate.toLocaleString('en-US', { month: 'long' });
      const monthNumber = newDate.getMonth() + 1;
      const year = newDate.getFullYear();
      const value = `${monthNumber}-${year}`;
      const label = `${month} ${year}`;
      months.push({ value, label });
    }
  
    this.setState({ months });
  }

  

  handleChange = (selectedOption) => {
    this.setState({ viewmonth: false, selectedMonth: selectedOption.value });
    var status=this.state.selectstatus;
      this.props.getMonthContractInstallment(selectedOption.value,status)
        .then(() => {
          this.setState({ viewmonth: true });
        });
  }

  handleStatus = (e) => {
        var status=e.target.value;
        this.setState({ selectstatus: status });
        var selmonth=this.state.selectedMonth;
        this.props.getMonthContractInstallment(selmonth,status)
        .then(() => {
            this.setState({ viewmonth: true });
        });
  }

  handleEditInstallment(){
      const installid=this.state.feebreakid;
      const paystatus=this.state.paymentstatus;
      const paynote=this.state.paymentnotes;
      var status=this.state.selectstatus;
      var selmonth=this.state.selectedMonth; 
      if(paystatus==''){
            this.setState({ 
                payerror:'Please select the payment status',
            });
      }else{
        this.props.updateInstallmentStatus(installid,paystatus,paynote)
        .then(() => {
          this.props.getMonthContractInstallment(selmonth,status);
          this.setState({ editAgreementModal: false });
        });
      }
     
  }

  onEditSession1(rawid){    
    
    this.setState({        
        feebreakid:rawid,
        paymentstatus:'',
        paymentnotes:'',
        payerror:'',
        editAgreementModal:true,
    });
    
  }

  onSendEmail(ctid){
   
    var status=this.state.selectstatus;
    var selmonth=this.state.selectedMonth; 
      this.props.emailInstallmentDue(ctid).then((data) => {
        this.props.getMonthContractInstallment(selmonth,status);
      });
  }
  

  render() {
    const { installmentlist, loading } = this.props;
    const { viewmonth, months, finmonth } = this.state;
    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        responsive:'standard',
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
      };
  
      const columns = [
        { name: 'sno', label: 'SNO.' },
        { name: 'student', label: 'STUDENT', options: {
          customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
       } },
        { name: 'installment', label: 'INSTALMENT NO', options: {
          customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap',textAlign:'center' }}>{value}</div>
       } },
        { name: 'duedate', label: 'DUE DATE', options: {
          customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
       } },
        { name: 'fees', label: 'FEES', options: {
          customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
       } },
        { name: 'tax', label: 'TAX', options: {
          customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
       } },
        { name: 'status', label: 'STATUS', options: {
          customBodyRender: (value) => <div style={{ whiteSpace: 'nowrap' }}>{value}</div>
       } },
        { name: 'notes', label: 'NOTES'},
        { name: 'action', label: 'ACTION' },
        { name: 'email', label: 'EMAIL' },
      ];
  
      const tableData = installmentlist.map((data,index) => {
        if(data.ctfb_emailsend==1){
          var shbtn='mr-10 mb-10 btn btn-info btn-sm text-white';
          var btl='Sent';
        }else{  
          // var shbtn='mr-10 mb-10 btn btn-secondary btn-sm text-white';
          // var btl='Send Email';
           var shbtn = 'mr-10 mb-10 btn btn-sm text-white bg-secondary border-0';
           var btl = 'Send Email';
        }
        const ebtn = (
            <MatButton className="btn-info mr-10 mb-10 text-white" onClick={() => this.onEditSession1(data.ctfbID)}>
              Edit
            </MatButton>
         );
        const mailbtn=(
          <MatButton className={shbtn} onClick={() => this.onSendEmail(data.ctfbID)}>
           {btl}
          </MatButton>
       ); 

        return {
          sno: index + 1,
          student: data.studentname,
          installment:data.installmentno,
          duedate:data.duedate,
          fees:data.ctfb_fees,
          tax:data.ctfb_tax,
          status:data.status,
          notes:data.ctfb_paynotes,
          action:ebtn,
          email:mailbtn,
        };
      });


    return (
      <div className="saas-dashboard">
        {this.state.viewdiv && (
          <>
            <div className="row">
                <div className="form-group col-sm-12 col-xl-4" style={{marginBottom:"30px"}}>
                    <label className="form-control-label" htmlFor="input-username">Select Month </label>
                    <FormGroup>
                      <Label for="Select" style={{ fontWeight: "bold" }}>Select Month</Label>
                      <Selectsearch
                        id="month"
                        name="month"
                        options={months}
                        value={months.find(obj => obj.value === this.state.selectedMonth)}
                        onChange={this.handleChange}
                        required
                      />
                    </FormGroup>
                </div>
                <div className="form-group col-sm-12 col-xl-4" style={{marginBottom:"30px"}}>
                    <FormGroup>
                            <Label for="Select">Select Status</Label>
                            <Input type="select" name="selectstatus" id="selectstatus" value={this.state.selectstatus} onChange={evt => this.handleStatus(evt)}>
                            <option value="0">All</option>
                            <option value="1">Paid</option>
                            <option value="2">Partial Paid</option>
                            <option value="3">Delayed</option>                                          
                            </Input>
                    </FormGroup>
                  
                </div>
            </div>
            <div className="col-sm-12 col-lg-12">
                <MUIDataTable data={tableData} columns={columns} options={options} />
            </div>
          </>
        )}

        {this.state.editAgreementModal && (
            <Dialog open={open} PaperProps={{ style: { width: 576 } }}>
                <DialogTitle>
                    <div disableTypography style={{ textAlign: 'center', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>Edit Installment</span>
                        <CloseIcon onClick={() => this.setState({ editAgreementModal: false })} style={{ cursor: 'pointer' }} />
                    </div>
                </DialogTitle>
                <DialogContent style={{ width: '100%' }}>
                    
                    <FormGroup>
                        <Label for="Select">Payment Status</Label>
                        <Input type="select" name="paymentstatus" id="paymentstatus" required value={this.state.paymentstatus} onChange={evt => this.setState({paymentstatus: evt.target.value})}>
                        <option value=""> </option>
                        <option value="1">Paid</option>
                        <option value="2">Partial Paid</option>
                        <option value="3">Delayed</option>                                          
                        </Input>
                    </FormGroup>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label class="col-form-label">Payment Notes</label>
                        <textarea rows="3" type="text" name="mskskill" id="mskskill" className="form-control form-control-alternative" value={this.state.paymentnotes} onChange={evt => this.setState({paymentnotes: evt.target.value})} ></textarea>                                      
                    </div>
                    <div className="row" style={{color:"red"}}>{this.state.payerror}</div>
                </DialogContent>
                <DialogActions className="d-flex justify-content-center">
                    
                    <button type="button" className="btn btn-outline-primary" onClick={() => this.handleEditInstallment()}>
                        <strong>Update</strong>
                    </button>
                </DialogActions>
            </Dialog>
        )}
        
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { contractDashboard } = state;
  return {
    installmentlist: contractDashboard.contractinstallmentlist,
    loading: contractDashboard.loading
  };
};

export default connect(mapStateToProps, {
  getMonthContractInstallment,
  updateInstallmentStatus,
  emailInstallmentDue
})(ContractsInstallment);
